import React, { useState,useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BreadCrumb = ({rutas}) => {
    const { t } = useTranslation('nav');
    const location = useLocation();
    const [breadcrumbs, setBreadcrumbs] = useState([]);

    let local = location.pathname.charAt(1).toUpperCase()+location.pathname.slice(2);
    if(local.split('/').length==2 || local.split('/').length==3){    
        local = local.split('/')[0]
    }    

    useEffect(() => {
        setBreadcrumbs(rutas);
      }, [rutas]);

    return ( 
        
        <>
            <div style={{ marginLeft: 10, padding:'20px 0', fontSize: 12}}>
                <Link to="/" style={{color:'#9b9898 !important'}}>{t('breadcrumb.home')}</Link>
                {breadcrumbs.map((breadcrumb, index) => (
                    <span key={index}>
                    &nbsp;/&nbsp;
                    {index === breadcrumbs.length - 1 ? (
                        breadcrumb.label
                    ) : (
                        <Link to={breadcrumb.path} style={{color:'#9b9898 !important'}}>{breadcrumb.label}</Link>
                    )}
                    </span>
                ))}
            </div>
            
        </>
           

        
    );
}
 
export default BreadCrumb;